import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  instruments: [],
  instrumentInfo: {},
  categories: [],
  active: null,
  menu: [],
  symbolSubscribe: []
};

const setStorage = (obj) => {
  localStorage.setItem('symbol_menu_list', JSON.stringify(obj));
};

const instrumentSlice = createSlice({
  name: 'instrument',
  initialState,
  reducers: {
    setInstrument(state, action) {
      state.instruments = action.payload;
    },
    setSymbolInfo(state, action) {
      state.instrumentInfo = state.instruments.find((e) => e.symbol === state.active);
    },
    setCategories(state, action) {
      state.categories = action.payload;
    },
    setSymbolActive(state, action) {
      const accountId = localStorage.getItem('iuxmarkets.active.account');
      const temp = {
        ...state.menu,
        [accountId]: {
          ...state.menu[accountId],
          active: action.payload
        }
      };
      setStorage(temp);
      state.active = action.payload;
      state.menu = temp;
    },
    setMenuSymbol(state, action) {
      const { type, symbol, active, data } = action.payload;
      if (type === 'new') {
        const currentMenu = state.menu[active]?.menu || [];
        setStorage({
          ...state.menu,
          [active]: {
            menu: [...currentMenu, { symbol: symbol }],
            active: symbol
          }
        });
        state.menu = {
          ...state.menu,
          [active]: {
            menu: [...currentMenu, { symbol: symbol }],
            active: symbol
          }
        };
      }
      if (type === 'del') {
        const accountId = localStorage.getItem('iuxmarkets.active.account');
        const currentMenu = state.menu[accountId]?.menu || [];
        const del = currentMenu.filter((e) => e.symbol !== symbol);

        setStorage({
          ...state.menu,
          [accountId]: {
            active: active,
            menu: del
          }
        });
        state.menu = {
          ...state.menu,
          [accountId]: { menu: del, active: active }
        };
        state.active = active;
      }
      if (type === 'first' || type === 'old') {
        setStorage(data);
        state.menu = data;
        state.active = data[data.accountId]?.active;
      }
    },
    setSymbolSubscribe(state, action) {
      state.symbolSubscribe = action.payload;
    }
  }
});

export const {
  setInstrument,
  setCategories,
  setSymbolActive,
  setMenuSymbol,
  setSymbolInfo,
  setSymbolSubscribe
} = instrumentSlice.actions;

const instrumentReducer = instrumentSlice.reducer;
export default instrumentReducer;
